import { useMemo } from "react";
import { FONT_FAMILY } from "@/utils/font-family";
import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { useTheme } from "@/contexts/theme/useTheme";

const useStyle = () => {
  const { neutralColor, primaryColor, theme } = useGomakeTheme();
  const { currentTheme } = useTheme();
  const isHpClient = currentTheme === "hp-client";

  const classes = useMemo(() => {
    return {
      logoutContainer: {
        flex: 1,
        minWidth: 0,
        ...(isHpClient
          ? {
              fontFamily: '"Forma DJR UI", sans-serif',
              fontWeight: 400,
              fontSize: 16,
              lineHeight: "19px",
              color: "#787878",
            }
          : {
              ...FONT_FAMILY.Lexend(500, 14),
              color: neutralColor(600),
            }),
      },
      menuItemContent: {
        boxSizing: "border-box" as const,
        display: "flex",
        flexDirection: "row" as const,
        alignItems: "center",
        width: "100%",
        gap: isHpClient ? "12px" : "8px",
      },
      menuItemIcon: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,
        width: 24,
        height: 24,
        lineHeight: 0,
      },
      menuItem: isHpClient
        ? {
            boxSizing: "border-box" as const,
            display: "flex",
            flexDirection: "row" as const,
            alignItems: "center",
            alignSelf: "stretch" as const,
            width: "100%",
            minHeight: 48,
            height: 48,
            padding: "12px 8px",
            gap: "12px",
            borderBottom: "1px solid #E8E8E8",
            fontFamily: '"Forma DJR UI", sans-serif',
            fontWeight: 400,
            fontSize: 16,
            lineHeight: "19px",
            color: "#787878",
          }
        : {
            width: "100%",
            ...FONT_FAMILY.Lexend(500, 14),
            color: neutralColor(600),
            gap: "8px",
            paddingTop: "12px",
            paddingBottom: "12px",
            paddingLeft: "16px",
            paddingRight: "16px",
          },
      lineContainer: {
        display: isHpClient ? "none" : "flex",
        width: "100%",
        height: 1,
        backgroundColor: "#cccccc",
      },
    };
  }, [theme, isHpClient, neutralColor]);

  return {
    classes,
    primaryColor,
  };
};
export { useStyle };
